import { LegacySyncFeaturePage } from "..";

/** 旧系统数据同步页面。 */
export function LegacySyncPage() {
  return <LegacySyncFeaturePage />;
}

/** 旧系统测试库数据同步页面。 */
export function LegacySyncTestPage() {
  return (
    <LegacySyncFeaturePage
      endpointPrefix="/legacy-sync-test"
      title="数据同步到测试库"
      description="用于把旧系统测试库数据同步到新系统测试库，功能与正式同步一致，但源库和目标库均为测试环境。"
      notice="测试库同步会写入 test_flower_master，并读取 test_FlowerWebSite；请确认当前操作不是正式库同步。"
    />
  );
}
